/**
 * Porte de l'aperçu de l'épreuve de vente — `/regie-test-vente`.
 *
 * MÊME gate WorkOS que l'admin du test (`RegieTestAdminGate`), et pas une
 * route publique : la consigne de l'épreuve est explicite et le scénario est
 * la réponse au test. Une URL devinable la mettrait entre les mains des
 * candidats avant qu'ils la passent.
 *
 * Cette route est un APERÇU, pas le parcours : rien n'est persisté, aucun
 * jeton, aucune fiche. Elle existe pour que Kayla joue l'épreuve et tranche
 * avant qu'on la branche dans le parcours candidat.
 */
import { Authenticated, AuthLoading, Unauthenticated } from "convex/react";

import { AuthLoadingScreen, LoginScreen } from "@/core/auth";

import { IS_MOCK_MODE } from "./api";
import { ApercuVente } from "./candidate/vente/ApercuVente";

export function VenteApercuGate() {
  if (IS_MOCK_MODE) {
    return <ApercuVente />;
  }

  return (
    <>
      <AuthLoading>
        <AuthLoadingScreen />
      </AuthLoading>
      <Unauthenticated>
        <LoginScreen />
      </Unauthenticated>
      <Authenticated>
        <ApercuVente />
      </Authenticated>
    </>
  );
}
